
<template>
  <div class="content live-wrapper">
    <!--  视频-->
    <div class="lp-player-box" ref="playBox">
      <div class="vjs-big-play-centered">
        <!--      直播未开始提示-->
        <div class="not-start-box-play">
          <div class="live-status-0" v-if="isLiveStatusShow">
            <span>直播未开始</span>
          </div>
          <img class="live-status-0-img" v-if="isLiveStatusShow" :src="live_info.cover" alt="" />
        </div>
        <!--      直播未开始提示-->
        <video id='myVideo' ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered vjs-fluid"
               playsinline
               x5-video-player-fullscreen="true"
               x5-playsinline
               webkit-playsinline
               autoplay
               allow="autoplay"
               x-webkit-airplay="true"
               x5-video-player-typ="h5">
          <source :src="video_src" type="application/x-mpegURL">
        </video>
      </div>
    </div>
    <!--  视频-->

    <!--    顶部-->
    <div id="lp-header">
      <!-- 标题 在线人数 点赞 留言数 -->
      <div class="lp-ht-row justify-align">
        <span style="padding-left: 2.66667vw;">
          <van-icon @click="goPage" name="arrow-left" />
          <strong><van-notice-bar scrollable color="#ffffff" background="none" :text="video_title"/></strong>
        </span>
        <!--        <span>-->
        <!--          <van-icon style="margin-right: 0.66667vw;" name="friends-o" />3193-->
        <!--        </span>-->
        <!--        <span>-->
        <!--          <van-icon style="margin-right: 0.66667vw;" name="comment-o" />3193-->
        <!--        </span>-->
        <div class="left-justifying rt-box">
          <div class="subscribe-cont" v-if="live_info.subscribable" @click="isCheckPhone">
            <img class="yue-img" :src="require('../../assets/'+appTheme+'/zhibo_yue.png')" alt="" />
            <wx-open-subscribe :template="templateIds[0]" id="subscribe-btn" ref="subscribeBtn">
              <script type="text/wxtag-template">
                <style>
                  .btn2 {
                    border: none;
                    position:absolute;
                    z-index:2;
                    opacity: 0;
                    left:0;top:0;
                    right:0;
                    bottom:0;
                    width:100%;
                    height:100%;
                  }
                </style>
                <button class="btn2"></button>
              </script>
            </wx-open-subscribe>
          </div>
          <img class="vr-img" @click="goVr" v-if="live_info.vr_url != null" :src="require('../../assets/'+appTheme+'/zhibo_vr_des.png')" alt="" />
          <div class="left-justifying div-number">
            <img :src="require('../../assets/'+appTheme+'/zhibo_wode.png')" alt="" />
            <span>{{clickNumber}}</span>
            <!--          <span class="hint-num">播放</span>-->
          </div>
        </div>

      </div>
    </div>
    <!-- 左1按钮分组 -->
    <div class="lp-icon-group" id="lp-icon-1">
      <!--    <div class="lp-icon-item" @click="clickShowBag"><img src="../../assets/zhibo_red1.png" alt="" /></div>-->
      <!-- 1元购物 -->
      <div class="lp-icon-item" @click="clickShowBagOne"><img :src="require('../../assets/'+appTheme+'/zhibo_red2.png')" alt="" /></div>
      <!-- 优惠券 -->
      <div class="lp-icon-item" @click="goQuan"><img :src="require('../../assets/'+appTheme+'/zhibo_red3.png')" alt="" /></div>
      <!--      <div class="coupon-icon">-->
      <!--        <span>0</span>-->
      <!--      </div>-->
      <!-- 红包 -->
      <div class="lp-icon-item" @click="red_bag_show = true"><img :src="require('../../assets/'+appTheme+'/zhibo_red4.png')" alt=""></div>
      <!--      &lt;!&ndash; 付费礼物 &ndash;&gt;-->
      <div class="lp-icon-item" @click="showGift"><img :src="require('../../assets/'+appTheme+'/zhibo_gift.png')" alt=""></div>
    </div>
    <!-- 左1按钮分组end -->
    <!-- 右3按钮分组 -->
    <div id="lp-icon-4" class="lp-icon-group">

      <!-- 1元购物 -->
      <!--    <div class="lp-icon-item"><img src="../../assets/zhibo_pl.png" alt="">8888</div>-->
      <!--    <div class="lp-icon-item" @click="clickHint"><img src="../../assets/zhibo_douyin.png" alt=""></div>-->
      <!--    <div class="lp-icon-item" @click="clickHint"><img src="../../assets/zhibo_live_icon.png" alt=""></div>-->
      <div class="lp-icon-item" @click="clickLike"><img :src="require('../../assets/'+appTheme+'/zhibo_like2.png')" alt="">{{likesNumber}}</div>
      <div class="lp-icon-item" @click="shareClick"><img :src="require('../../assets/'+appTheme+'/zhibo_share_red.png')" alt=""></div>
    </div>
    <!-- 右3按钮分组end -->

    <!--  弹框-->
    <van-overlay :show="red_bag_show" @click="red_bag_show = false">
      <div class="red_bag_wrapper" @click.stop>
        <div class="block">
          <div class="red-bag-item left-justifying">
            <span class="red-name">数量</span> <van-field placeholder="请输入数量" v-model="redNumber" type="digit" class="input-bag" /><span>个</span>
          </div>
          <div class="red-bag-item left-justifying">
            <span class="red-name">总金额</span> <van-field placeholder="请输入金额" v-model="redSum" class="input-bag" type="number" /><span>元</span>
          </div>
          <div class="btn-red-bag-box justify-align">
            <van-button class="red-btn" round size="small" type="primary" style="color: #fff;background: #d2d2d2;" @click="red_bag_show = false">关闭</van-button>
            <van-button class="red-btn" round size="small" type="info" @click="sendRedBig" :disabled="sendRedDisabled">发红包</van-button>
          </div>
        </div>

      </div>
    </van-overlay>
    <!--  扫码关注end-->

    <!--  扫码关注-->
    <div class="qr-code-box">
      <div class="txt">关注</div>
      <div class="txt">全球灯云</div>
      <div class="qr-code" @click="showQrCode">
        <van-icon name="qr" />
      </div>
    </div>
    <!--  弹框-->
    <van-overlay :show="qr_show" @click="qr_show = false">
      <div class="qr_zs_wrapper">
        <div class="block">
          <img :src="require('../../assets/'+appTheme+'/qr_zs.png')" alt="" />
          <span>扫一扫关注全球灯云</span>
        </div>

      </div>
    </van-overlay>
    <!--  扫码关注end-->
    <!--    消息-->
    <div class="fake-chat-msg comment">
      <div class="fake-chat-inner comment-wrap" ref="wrapper" id="wrapper">
        <ul class="list" ref="list" id="list-msg">
          <li class="li" v-for="(item,index) in msgList" :key="index" :class="[item.type==1?'left-justifying2':'left-justifying3']">
            <span class="name nickname">{{item.nickname}}：</span>
            <span class="content" v-if="item.type==1">
              <div class="red-box" :style="{background:(item.is_took_live_room_red_envelope ==1||item.live_room_red_envelope_status == 1)?'#d0bd93':'#FFA500'}" @click="redPacketShowClick(item)">
                <div class="red-bag-title left-justifying"><img :src="require('../../assets/'+appTheme+'/zhibo_red_icon_chat.png')" alt="" /><p>{{item.live_room_red_envelope_sub_status==1?'已领取':'领取'}}红包</p></div>
                <div class="red-name">{{item.nickname}}红包</div>
              </div>
            </span>
            <div style="display: inline-block;" class="content content-sec" v-else>
              <span v-if="!item.is_translate">{{item.content}}</span>
              <span v-if="item.is_translate">{{item.content_sec}}</span>
              <div class="translate-box" v-if="!item.is_translate">
                <span @click="translateFirst(item,'zh')">中文</span><span @click="translateFirst(item,'en')">EN</span><span @click="showPopup(item)">多国翻译</span>
              </div>
              <div @click="showDefault(item)" v-if="item.is_translate" class="show-default"><van-icon name="exchange" />显示原文</div>
              <div v-if="item.arr" class="que">
                <div v-for="(que,i) in item.arr" :key="i">
                  <p v-if="!que.is_translate" style="line-height: 5.33333vw;margin-bottom: 0.66667vw;text-decoration: underline;" @click.stop="details(que)">{{i + 1}}、{{que.content}}</p>
                  <p style="line-height: 5.33333vw;margin-bottom: 0.66667vw;text-decoration: underline;" v-if="que.is_translate" @click.stop="details(que)">{{i + 1}}、{{que.content_sec}}</p>
                  <div class="translate-box" v-if="!que.is_translate">
                    <span @click="translateSec(que,'zh')">中文</span><span @click="translateSec(que,'en')">EN</span><span @click="showPopup(que)">多国翻译</span>
                  </div>
                  <div @click="showDefault(que)" v-if="que.is_translate" class="show-default" style="padding-bottom: 1.6vw;margin-top: undefined;"><van-icon name="exchange" />显示原文</div>
                </div>


              </div>
            </div>


          </li>
        </ul>
      </div>
      <div class="rest-nums" v-show="restComment" @click="scrollBottom">{{restComment}}条新消息</div>
    </div>
    <!--说点什么-->
    <!--  <div id="fake-chat-form" @click="panelShow">-->
    <!--    说点什么-->
    <!--  </div>-->
    <!--  <div class="gift-box"><img src="../../assets/zhibo_liwu.png" alt="" /></div>-->

    <div class="chat-wrapper" v-if="!msgShow">
      <div class="chat-wrapper-content content-center">
        <div class="goods-box" @click="clickShowBag"><img :src="require('../../assets/'+appTheme+'/zhibo_goods.png')" alt="" /><span class="goods-number">{{goodsList.length}}</span></div>
        <div class="say-box" @click="panelShow">聊点什么...</div>
        <div class="bottom-item-box justify-align">
          <div class="item-img" @click="goHome"><img :src="require('../../assets/'+appTheme+'/zhibo_home.png')" alt="" /></div>
          <!--        <div class="item-img" style="margin: 0 2vw;"><img src="../../assets/zhibo_dian.png" alt="" /></div>-->
          <!--        <div class="item-img"><img src="../../assets/zhibo_serve.png" alt="" /></div>-->
        </div>
      </div>

    </div>

    <!--  发送消息弹框-->
    <!-- 输入框区域box -->
    <div class="input-box-bg" @click="hideClick" v-if="msgShow"></div>
    <div class="input-box" ref="heightFace" v-if="msgShow">
      <!-- 输入框区域 -->
      <div class="input-content left-justifying">
        <van-icon size="32" color="#fff" @click="faceContent" name="smile-o" />
        <input v-model="textConent" class="input-txt" maxlength="20" type="text" />
        <!--        <van-icon size="24" color="#fff" @click="referContent" name="back-top" />-->
        <van-button :disabled="btnIsSend" round class="send-btn" @click="referContent" name="back-top">发送</van-button>
      </div>
      <!-- 表情区域 -->
      <div class="browBox" v-if="faceShow">
        <ul>
          <li v-for="(item,index) in faceList" :key="index" @click="getBrow(index)">{{item}}</li>
        </ul>
      </div>
    </div>
    <!--  消息弹框end-->
    <!--  购物袋-->
    <van-action-sheet v-model="shopBig" title=" " :closeable="true">
      <div class="content-pop">
        <div class="p-title-box justify-align">
          <span class="title">共{{goodsList.length}}件商品</span>
          <div class="left-justifying">
            <!--          <div class="pop-item" style="margin-right: 5.33333vw;">-->
            <!--            <img src="../../assets/allShop.png" alt="" />-->
            <!--            店铺商品-->
            <!--          </div>-->
            <div class="pop-item" @click="goCart">
              <img :src="require('../../assets/'+appTheme+'/shopCar.png')" alt="" />
              购物车
            </div>
          </div>
        </div>
        <div class="goods-list-box">
          <div class="goods-item left-justifying" style="align-items: flex-start;" v-for="(item,index) in goodsList" :key="index" @click="goDes(item)">
            <div class="goods-img-box">
              <div class="hint-num">{{index+1}}</div>
              <img :src="item.image" alt="" />
            </div>
            <div class="goods-content">
              <div class="goods-title">{{item.name}}</div>
              <div class="goods-des justify-align">
                <div class="price-box" v-if="item.first_price != null">
                  ￥<span> {{item.first_price}}</span>
                </div>
                <div class="price-box" v-else>
                  ￥<span> {{item.price}}</span>
                </div>
                <div class="buy-news">马上抢</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <!--  购物袋end-->
    <!--  1元购物袋-->
    <van-action-sheet v-model="shopBigOne" title=" " :closeable="true">
      <div class="content-pop">
        <div class="p-title-box justify-align">
          <span class="title">共{{goodsList.length}}件商品</span>
          <div class="left-justifying">
            <!--          <div class="pop-item" style="margin-right: 5.33333vw;">-->
            <!--            <img src="../../assets/allShop.png" alt="" />-->
            <!--            店铺商品-->
            <!--          </div>-->
            <div class="pop-item" @click="goCart">
              <img :src="require('../../assets/'+appTheme+'/shopCar.png')" alt="" />
              购物车
            </div>
          </div>
        </div>
        <div class="goods-list-box">
          <div class="goods-item left-justifying" style="align-items: flex-start;" v-for="(item,index) in goodsListOneArr" :key="index" @click="goDes(item)">
            <div class="goods-img-box">
              <div class="hint-num">{{index+1}}</div>
              <img :src="item.image" alt="" />
            </div>
            <div class="goods-content">
              <div class="goods-title">{{item.name}}</div>
              <div class="goods-des justify-align">
                <div class="price-box" v-if="item.first_price != null">
                  ￥<span> {{item.first_price}}</span>
                </div>
                <div class="price-box" v-else>
                  ￥<span> {{item.price}}</span>
                </div>
                <div class="buy-news">马上抢</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <!--  1yuan 购物袋end-->
    <!--  红包领取弹框-->
    <van-overlay :show="redPacketShow" @click="redPacketShow=false">
      <div class="red-packet-bpx" @click.stop>
        <!--      红包未开-->
        <template v-if="redType==1">
          <img class="red-packet-bpx-img" :src="require('../../assets/'+appTheme+'/h_b_bg.png')" alt="" />
          <div class="red-packet-content">
            <div class="red-packet-title">你有{{live_room_red_money.amount}}元惊喜红包</div>
            <div class="red-packet-hint">待领取！</div>
            <div class="red-packet-time">{{showTime.H}}:{{showTime.M}}:{{showTime.S}}</div>
            <div class="red-packet-get">后可领</div>
            <div class="red-packet-btn">等一等领红包</div>
          </div>
        </template>
        <!-- 红包未开end-->
        <!-- 红包开-->
        <template v-if="redType==2">
          <img class="red-packet-bpx-img" :src="require('../../assets/'+appTheme+'/h_b_bg2.png')" alt="" />
          <div class="money-box-red">
            <p>您有一个惊喜红包</p>
            <p>待领取！</p>
          </div>
          <img class="open-btn" @click="takeRedEnvelopeClick" :src="require('../../assets/'+appTheme+'/red_open.png')" alt="" />
        </template>

        <!-- 红包开end-->
        <!-- 红包已领取-->
        <template v-if="redType==3">
          <img class="red-packet-bpx-img" :src="require('../../assets/'+appTheme+'/h_b_bg2.png')" alt="" />
          <div class="red-packet-content">
            <div class="red-packet-title red-packet-title-sec">￥<span>{{live_room_red_money.amount}}</span></div>
            <div class="red-packet-hint red-packet-hint-sec">恭喜获得惊喜红包</div>
            <div class="red-packet-btn red-packet-btn-sec" @click="redPacketShow = false">好</div>
          </div>
        </template>
        <!-- 红包已领取end-->
      </div>
    </van-overlay>
    <!--  红包领取弹框end-->
    <!--  优惠券弹框-->
    <van-overlay :show="discountShow" @click="discountShow = false">
      <div class="discount-box">
        <img class="discount-img-bg" :src="require('../../assets/'+appTheme+'/c_bg_zhibo.png')" alt="" />
        <div class="ticket-priority-box" v-if="discountInfo.type=='ticket'">
          <div class="priority-title">恭喜获得您</div>
          <div class="priority-title-sec"><span>{{discountInfo.title}}</span></div>
          <div class="priority-goods" v-if="discountInfo.one_pay_goods != ''">{{discountInfo.one_pay_goods.goods.name}}</div>
          <div class="priority-goods-hint">商品购买资格</div>
        </div>
        <div class="ticket-priority-box" v-else-if="discountInfo.type=='subsidy'">
          <div class="priority-title">恭喜获得您</div>
          <div class="priority-goods-hint">{{discountInfo.sufficient_amount=='0.00'?'无门槛':'满'+discountInfo.sufficient_amount+'减'}}</div>
          <div class="priority-title-sec">{{discountInfo.amount}}<span>元</span></div>
          <div class="priority-goods">{{discountInfo.title}}</div>
          <!--          <div class="priority-goods-hint">{{discountInfo.sufficient_amount=='0.00'?'无门槛代金券指定店铺':'满减代金券不指定店铺'}}</div>-->

        </div>
        <div class="discount-box-content" v-else>
          <div class="number">{{discountInfo.discount | filterDiscount}}</div><span>折</span>
        </div>
        <div class="discount-btn" @click="clickCoupon">马上领券</div>
      </div>
    </van-overlay>
    <!--  优惠券弹框end-->
    <!--  优惠券领取成功弹框-->
    <van-overlay :show="discountSucceed" @click="discountSucceed = false">
      <div class="discount-box">
        <img class="discount-img-bg" :src="require('../../assets/'+appTheme+'/c_bg_zhibo.png')" alt="" />
        <div class="discount-box-content discount-box-content-succeed">
          <div class="ticket-priority-box ticket-priority-box-sec" v-if="discountInfo.type=='ticket'">
            <div class="priority-title">恭喜获得您</div>
            <div class="priority-title-sec"><span>{{discountInfo.title}}</span></div>
            <div class="priority-goods" v-if="discountInfo.one_pay_goods != ''">{{discountInfo.one_pay_goods.goods.name}}</div>
            <div class="priority-goods-hint">商品购买资格</div>
          </div>
          <div class="red-packet-hint" v-else-if="discountInfo.type=='subsidy'">
            <div style="margin-bottom: 1.33333vw;"> 恭喜获得<div class="number" style="margin-left: 1.33333vw;">{{discountInfo.amount}}</div><span>元</span></div>
            代金券
          </div>
          <div class="red-packet-hint" v-else>
            <div style="margin-bottom: 1.33333vw;"> 恭喜获得<div class="number" style="margin-left: 1.33333vw;">{{discountInfo.discount | filterDiscount}}</div><span>折</span></div>
            优惠券
          </div>

        </div>
        <div class="discount-btn" @click="clickCouponSucceed">好</div>
      </div>
    </van-overlay>
    <!--  优惠券弹框end-->
    <!--  是否有人进入直播间提示-->
    <div class="head-live-box" v-if="comeInAnimation">
      <div class="left-justifying">
        <!--      <img src="" alt="" />-->
        欢迎<div class="name">{{welcomeMsg.nickname}}</div>进入直播间
      </div>
    </div>
    <!--  是否有人进入直播间提示end-->
    <!--  是否有他人人进入直播间提示-->
    <div class="head-live-box" v-if="comeInAnimationHe">
      <div class="left-justifying">
        <!--      <img src="" alt="" />-->
        欢迎<div class="name">{{welcomeMsgHe.nickname}}</div>进入直播间
      </div>
    </div>
    <!--  是否有人进入直播间提示end-->
    <!-- 分享弹框star -->
    <van-overlay :show="shareShow">
      <div class="wrapper" @click.stop>
        <div class="icon-box" @click="shareShowHide">
        <span class="icon-box-bg">
          <van-icon size="24" color="#fff" name="cross" />
        </span>
        </div>
        <img v-if="posterUrl" class="poster-url" crossorigin="anonymous" :src="posterUrl" alt="" />
        <div class="imageWrapper" v-else id="imageWrapper" ref="imageTofile">
          <img v-if="live_info" class="img-goods goodsImg" :src="live_info.cover" alt="" />
          <div class="title">{{live_info.title}}</div>
          <img ref="qrcode" class="qr-code-img" :src="qrcodeUrl" alt="" />
          <div class="hint">长按二维码保存图片</div>
        </div>
      </div>
    </van-overlay>
    <!-- 分享弹框end -->
    <div class="hidden" style="display: none;">
      <!--    width: 69.33333vw; height: 118.66667vw;-->
      <vue-canvas-poster v-if="qrcodeUrl" :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>
    <!-- 分享弹框end -->
    <!--  语言翻译选择框弹出框内容-->
    <van-popup v-model="pop_show" position="top" closeable :style="{ height: '25%' }">
      <div class="list-language-box justify-align">
        <span class="language-item" v-for="(item,i) in languageList" :key="i" @click="languageSelect(i)">{{item}}</span>
      </div>
    </van-popup>
    <!--  礼物弹框star-->

    <van-action-sheet v-model="gift_show" title=" " :closeable="true" style="height: 40%;" @close="clickCloseGift">
      <div class="gift-wrapper">
        <div class="gift-list">
          <div :class="[activeGift == index?'gift-item-active':'','gift-item']" v-for="(item,index) in giftList" :key="index" @click="clickGiftItem(item,index)">
            <img class="img-gift" :src="item.static_image" alt="" />
            <div class="price">￥{{item.amount}}</div>
            <van-button :disabled="sendGiftDisabled" v-if="activeGift == index" class="pay-gift-sec" @click="clickPayGift(item,index)">赠送</van-button>
          </div>
        </div>
        <!--      <van-button type="primary" round class="pay-gift" :disabled="sendGiftDisabled" @click="submitGiftPay">确定支付(￥{{giftObj.amount}})</van-button>-->
      </div>
    </van-action-sheet>
    <!--  礼物弹框-->
    <div class="show-gift-img" v-if="show_gif">
      <img :src="showGiftList[0].live_room_gift_image" alt="" />
    </div>

    <!--  礼物提示-->
    <div class="head-live-box-gift" v-if="show_gif">
      <div class="left-justifying">
        <div class="head-live-box-gift-content">
          <div class="name">{{showGiftList[0].nickname}}</div>
          <div style="padding-bottom: 0.66667vw;">送出{{showGiftList[0].live_room_gift_title}}</div>
        </div>
        <!--      <div class="number-gift"><span>x</span>1</div>-->
      </div>
    </div>
    <!--  是否有人进入直播间提示end-->

    <!--  礼物弹框end-->

  </div>
</template>

<script>

import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { zhoboListDes, zhoboDesLike, loginZhiBo, getWechat, messageSubscribe,redEnvelopePay,takeRedEnvelope,zhiboListgGift,giftPay } from '@/api/zhibo'
import { languageList,translateSubmit } from '@/api/xieyi'
import QRCode from 'qrcode';
import { VueCanvasPoster } from 'vue-canvas-poster'
import smoothscroll from 'smoothscroll-polyfill';
import { debounce, isScrollBottom } from '../../utils/timeUtils';
import { getDiscountCoupon } from '@/api/goods'
import store from "@/store";
smoothscroll.polyfill(); // 移动端scrollTo behavior: "smooth"动画失效的polyfill
// 导入JSON格式的表情库
const appData = require("@/assets/emojis.json");
const jweixin = require('jweixin-module');
// import jweixin from "jweixin-module"
export default {
  name: "zhiBoDes",
  components: {
    VueCanvasPoster
  },
  data(){
    return {
      appTheme:this.$store.state.appTheme,
      show_gif:false, // 是否显示gift
      gift_show:false,
      activeGift:-1, // 点击礼物某项
      giftList: [],// 弹框礼物数据
      giftListGif: [], // gif 数组
      giftObj:'',// 当前选中的礼物
      languageList: [],
      translateCurrItem:'',
      currLanguage:'',
      pop_show:false, // 多语言显示框
      sendRedDisabled:false,
      redNumber:'',
      redSum:'',
      red_bag_show: false,
      qr_show: false,
      msgShow: false, // 发送消息框
      textConent: "",
      faceList: [],
      faceShow: false,
      restComment: 0,
      restNums: 0,
      wrapperDom: null,
      listDom: null,
      wrapperHeight: 0,
      msgList: [], // 消息列表
      discountSucceed: false, // 优惠券成功提示
      redType:2, // 红包状态 1：倒计时中 2：开 3：打开后
      discountShow: false, //优惠券领取弹框
      redPacketShow: false, // 红包领取弹框
      live_room_red_envelope_id:'',// 红包id
      redCurrItem: '', //当前红包
      live_room_red_money:'',
      shopBig: false,
      shopBigOne:false,
      videoPlayer: undefined,
      videoSrc: '',
      activeNav: 0,
      panel_is_show: false,
      video_src:'',
      video_title:'',
      live_id:'',
      live_info:'',
      goodsList:[],
      goodsListOneArr:[],
      likesNumber: 0,
      clickNumber:0,
      phoneType: 1, // 1安卓 2:ios
      player: null,
      options: {
        muted: false, // 是否静音
        autoplay: false, // 播放器准备好之后，是否自动播放 【默认false】
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        //aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        controls: false, // 是否显示底部控制栏
        poster: 'xxx', // 视频封面图地址
        loop: false, // 是否循环播放:true/false
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          children: [
            {name: 'playToggle'}, // 播放按钮
            {name: 'currentTimeDisplay'}, // 当前已播放时间
            {name: 'progressControl'}, // 播放进度条
            {name: 'durationDisplay'}, // 总时间
            {
              name: 'volumePanel', // 音量控制
              inline: false, // 不使用水平方式
            },
            {name: 'FullscreenToggle'} // 全屏
          ]
        }
      },
      source: '',
      // source: '//ivi.bupt.edu.cn/hls/cctv1.m3u8',
      instance: null,
      endTime:'2021-12-12 15:58',
      finishedTime: '', // 活动结束时间
      msTxtShow: false, // false:显示倒计时  true：显示倒计时中
      showTime: {
        H: 0,
        M: 0,
        S: 0
      }, //倒计时
      live_status: 0, // 1 直播中 2热播 0 未开始
      wsUrl: '',
      zhiBoToken: '',
      // lockReconnect: false, //是否真正建立连接
      timeout: 28 * 1000, //30秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
      // 这里开始
      ws: null,//建立的连接
      wsuri:'', // ws wss
      lockReconnect: false, // 连接失败不进行重连
      maxReconnect: 10, // 最大重连次数，若连接失败
      groupOnline: 0,
      wsLinked: false,
      timer: null,
      comeInAnimation: false, // 是否显示有人进来提示
      comeInAnimationHe: false,// 是否显示有人进来提示
      btnIsSend:false, // 防止点击多次
      discountInfo: '', // 优惠券
      pressTimer: null, // 定时器
      liveroomId: '',
      userInfo:'',
      welcomeMsg: '',
      welcomeMsgHe: '', // 自己的
      is_first: 1, // 1是第一次进来 0不是
      qrcodeUrl: '', // 二维码
      shareItem: '',
      posterUrl:'', // 海报
      shareGoodsImg: '',
      shareShow:false,
      painting:{
        width: '510px',
        height: '600px',
        background: '#ffffff',
        borderRadius: '10px'
      },
      templateIds: [],
      isdy:false,
      live_time: '', // 开始时间
      isVideoBreak: '',
      timerPlay:'',// 判断视频是否卡死定时器
      hostUrl:'', // 当前域名
      giftData: '', // 刷的礼物数据
      sendGiftDisabled:false, // 礼物按钮
      showGiftList:[], // 礼物数组
      pwd_is_err:false, // 密码是否正确
      password:''
    }
  },
  computed: {
    isLiveStatusShow() { // 判断是否显示直播未开始
      if (this.live_status ==0 || this.live_status ==3 || this.live_status ==4 || this.live_status ==5 || this.live_status ==6){
        // console.log('true',this.live_status)
        return true;
      } else {
        // console.log('false',this.live_status)
        return false;
      }
    },
  },
  filters: {
    filterDiscount: function (value){
      var discount = value/10
      return discount
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //
    // })
    window.addEventListener("pagehide", this.pageHide); // 调用jssdk的页面增加事件
  },
  created() {
    let templateIds = []
    templateIds.push(window.g.templateIds[0])
    this.templateIds = templateIds
    var u = navigator.userAgent, app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isAndroid) {
      this.phoneType = 1 // isAndroid
      // alert("安卓机！")
    }
    if (isIOS) {
      // alert("苹果果机！")
      this.phoneType = 2 //  isIOS
    }

    this.live_id = this.$route.query.id
    console.log( window.g)
    if (this.$route.query.pwd){
      this.password = this.$route.query.pwd
    }

    this.getDes()
    // 高度自适应
    let width = document.documentElement.clientWidth
    let h = document.documentElement.clientHeight
    this.options.height = h+'px'
    this.options.width = width+'px'
    this.getLanguageList()
  },

  beforeRouteLeave(to, from, next) { //页面销毁时关闭长连接 功能没做好要隐藏
// 同时在beforeRouteLeave方法里关闭websocket的链接
    if (to.name !== 'zhiBoDes') {
      var that = this
      console.log('卸载界面')
      heartCheck.reset()
      that.lockReconnect = true
      that.msgList = []
      that.ws && that.ws.close()
      clearTimeout(that.timer);
      // clearInterval(that.timerPlay) 清除视频检测卡顿
      setTimeout(() => {
        this.$destroy()
      }, 1000)
    }
    next()
  },
  destroyed() { //页面销毁时关闭长连接  功能没做好要隐藏
    var that =this
    console.log('卸载界面关闭长连接')
    if (that.pwd_is_err){
      that.wsLinked = true
      //页面销毁时关闭长连接
      heartCheck.reset();
      that.ws.close()
      that.ws.onclose=function(e){
        console.log(e)//监听关闭事件
        console.log('关闭')
      }
      clearTimeout(that.timer);
      //移除事件处理程序 需要调用jssdk的页面
      window.removeEventListener("pagehide", this.pageHide);
      // 销毁video
      if (this.player) {
        this.player.dispose(); // 该方法会重置videojs的内部状态并移除dom
        this.video_src ='';
      }
    }
  },

  methods: {
    showDefault(it){
      this.translateCurrItem = it
      this.translateCurrItem.is_translate = false
      this.$forceUpdate()
    },
    translateFirst(it,type){ // 单个点击翻译的话
      console.log('it',it)
      // console.log(type)
      // this.pIndex = index
      this.translateCurrItem = it
      this.currLanguage = type
      this.clickTranslateSubmit()
    },
    translateSec(item,type){
      this.translateCurrItem = item
      this.currLanguage = type
      this.clickTranslateSubmit()
    },
    languageSelect(i){ // 弹框内容选中的语言
      console.log(i)
      this.currLanguage = i
      this.pop_show = false
      this.clickTranslateSubmit()
    },
    showPopup(item) { // 更多语言
      // console.log(item)
      this.translateCurrItem = item
      this.pop_show = true
    },
    getLanguageList(){ // 语言选择
      languageList().then(res=>{
        if (res.code==200){
          this.languageList = res.data
        } else
        {
          this.$toast(res.message)
        }
      })
    },
    clickTranslateSubmit(){ // 调取接口

      const data = {
        text:this.translateCurrItem.content,
        target_language:this.currLanguage
      }
      let that = this
      translateSubmit(data).then(res=>{
        if (res.code == 200){
          let txt = res.data
          let obj = that.translateCurrItem
          obj.is_translate = true
          obj.content_sec = txt
          that.translateCurrItem = obj
          // console.log('translateCurrItem',this.translateCurrItem)
          this.$forceUpdate()
        } else
        {
          this.$toast(res.message)
        }
      })
    },
    sendRedBig(){ // 发红包

      if (this.redNumber == ''){
        this.$toast('请输入数量')
        return false
      }else if (this.redSum == ''){
        this.$toast('请输入总金额')
        return false
      } else {
        this.sendRedDisabled = true
        let http = window.location.protocol+'//'
        let url = window.location.hostname // 获取当前访问（域名）
        let id = this.live_id
        // let baseUrl = http+url+`/payComeBack?id=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'
        const data = {
          amount:this.redSum,
          quantity:this.redNumber
        }
        redEnvelopePay(id,data).then(res => {
          // console.log(res)
          if(res.code == 200)
          {
            var url = res.data.url
            window.location.href=url // 安卓ok
            window.open(url) // ios no
            this.sendRedDisabled = false
            this.red_bag_show=false
          } else {
            this.$toast(res.message)
            this.sendRedDisabled = false
          }
        })
      }
    },
    redPacketShowClick(item){ // 当前列表点击领取
      if (item.is_took_live_room_red_envelope ==1||item.live_room_red_envelope_status == 1){
        this.$toast('红包已抢完')
      }else {
        this.redCurrItem = item
        this.redType=2 // 打开红包
        this.redPacketShow = true
      }
      console.log(item)

    },
    takeRedEnvelopeClick(){ // 领取红包

      // this.live_room_red_envelope_id = redId
      let msgIdCurr = this.redCurrItem.id
      const data = {
        live_room_red_envelope_id:this.redCurrItem.live_room_red_envelope_id,
      }
      takeRedEnvelope(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {  this.redPacketShow = true
            this.redType=3
          this.live_room_red_money= res.data
          const msgArr = this.msgList
          for (let i = 0;i< msgArr.length;i++){
            if (msgArr[i].id == msgIdCurr){
              msgArr[i].is_took_live_room_red_envelope = 1
            }
          }
          this.msgList = msgArr
        } else {
          this.$toast(res.message)
          this.timer = setTimeout(()=>{  //设置延迟执行
            this.redPacketShow = false
            clearTimeout(this.timer); //清除延迟执行

          },1000);
        }
      })
    },
    isCheckPhone(){ // 判断版本是否适合
      const ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i)=="micromessenger") { // 是否是微信
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) { // ios
          // ios系统就拼接随机字符串
          console.log('ios')
          var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
          console.log('wechatInfo')
          if ( wechatInfo[1] < '8.0.8' ) {
            // alert("本活动仅支持微信5.0以上版本")
            this.$toast('仅支持微信8.0.8以上版本,请升级微信版本')
            return false
          }else {
            // this.wxSubscribe()// 初始化微信
            console.log('版本可以')
          }

        } else {
          console.log('安卓')
          // this.wxSubscribe() // 初始化微信
        }
      }

    },
    showQrCode(){
      this.qr_show = true
    },
    goHome(){
      this.$router.push('/');
    },
    clickHint(){
      this.$toast('暂未开放，敬请期待')
    },
    goVr(){
      // console.log(2222)
      var url = this.live_info.vr_url
      window.open(url);
      window.location.href = url
    },
    async getUser () {
      const res = await this.$Http.getInfo()
      if (res.code == 200){
        const info = res.data;
        this.userInfo = info;
        console.log('res',res)
        this.$store.commit('setUserInfo', info)
      } else {
        this.$router.push('/');
      }
    },
    clickSubscribe(){
      // console.log('订阅')
      // this.getWxDes()
    },
    wxSubscribe(){ // 初始化微信
      console.log('初始化微信')
// 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
        console.log('ios')
      } else {
        console.log('安卓')
        pageUrl = location.href.split('#')[0]
      }

      var data = {
        liveUrl: pageUrl
      }
      console.log(data)
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          var weChat = res.data
          console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['wx-open-subscribe', 'launchAppLication','onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['wx-open-subscribe', 'wx-open-subscribe-dialog','onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData']
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            console.log('ready')
            // this.isdy = true
            // wx-open-subscribe 原生绑定点击事件
            this.$nextTick(() => {
              const that = this
              if (that.isdy){
                const btn = that.$refs.subscribeBtn;
                btn.addEventListener('success', ({detail}) => {
                  console.log('success',detail)
                  var content2 = JSON.parse(detail.subscribeDetails)
                  console.log(content2)
                  for (var i in content2) {
                    if (i === this.templateIds[0] || i === window.g.templateIds[0]) {
                      let status = JSON.parse(content2[i]).status
                      console.log(status)
                      console.log(content2)
                      if (status === 'accept') {
                        // 这里跟后端要个接口，绑定；
                        console.log('綁定')
                        that.sendSubscribe()
                      } else if (status === 'reject') {
                        alert('拒绝授权')
                      }
                    }
                  }
                });
                btn.addEventListener('error', (e) => {
                  alert('授权失败了，请重试')
                });

              }


              let urlPath = location.href.split('#')[0]
              // alert("准备完毕，加载方法");
              //分享到朋友圈
              jweixin.updateTimelineShareData({ // 朋友圈
                title: that.live_info.title,   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: that.live_info.cover,   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              });

              jweixin.onMenuShareTimeline({ // 旧版本
                title: that.live_info.title,   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: that.live_info.cover,   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              })

              //分享给朋友
              jweixin.updateAppMessageShareData({
                title: that.live_info.title,
                desc: '',
                link: urlPath, // keyi
                imgUrl: that.live_info.cover,
                success: function (n) {
                  console.log("分享成功", n);
                },
                complete: function (n) {
                  console.log(n);
                }
              });

              // 旧版本
              jweixin.onMenuShareAppMessage({
                title: that.live_info.title, // 分享标题
                desc:'',
                link: urlPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:that.live_info.cover, // 分享图标
                success: function (e) {
                  // 用户点击了分享后执行的回调函数
                  console.log('分享给朋友',e);
                }
              });


            })



          })

        } else {
          this.$toast(res.message)
        }
      })
    },
    sendSubscribe(){ // 订阅发送绑定
      const data = {
        live_room_id: this.live_id,
        template_id: this.templateIds[0]
      }
      messageSubscribe(data).then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data)
        }
        else
        {
          this.$toast(res.message)
        }
      })
    },
    pageHide(){ // /页面关闭或刷新时触发
      this.$store.commit("setWechatSignUrl", '');
    },
    subError(e) {
      console.log(e);
    },
    subSuccess(e) {
      console.log('订阅e',e)
      if (e.detail.errMsg == 'subscribe:ok') {
        let status = JSON.parse(e.detail.subscribeDetails);
        if (JSON.parse(status[window.g.templateIds[0]]).status == 'accept') {
          this.$toast.success('订阅成功');
        } else {
          this.$toast.fail('订阅失败');
        }
      } else {
        this.$toast.fail('订阅失败');
      }
    },
    getWsToken(){
      loginZhiBo().then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          this.zhiBoToken = res.data.liveToken

          if (this.zhiBoToken != ''){
            this.$store.commit("setZhiBoToken", this.zhiBoToken);
            this.iniWs() // 第一种方式 功能没做好要隐藏
          }
          // console.log('zhiBoToken',this.zhiBoToken)
        } else {
          this.$toast(res.message)
        }
      })
    },
    iniWs(){ // 初始化
      //const wsuri = "ws://sms.填写您的地址.com/websocket/" + this.charId; //ws地址
      // "type":"join","liveroomId":"2","uid":2

      let wsuri = window.g.wsuri

      //
      if (process.env.VUE_APP_MODE === 'development' || process.env.VUE_APP_MODE === 'test') {
        // 开发环境下的执行操作
         wsuri = window.g.wsuri
      } else {
        // 生产环境下的执行操作
        wsuri = window.g.wsuri
      }

      // wsuri = 'wss://best.itos.cn/wss/ws/'
      //建立连接

      var type1 = 'join'
      // console.log('iniWs',window.g.wsuri)
      console.log('iniWs',wsuri)
      this.ws = new WebSocket(wsuri+'?liveroomId='+this.liveroomId+'&type='+type1+'&token='+this.zhiBoToken);
      // this.ws = new WebSocket(url);
      //连接成功
      this.ws.onopen = this.wsOnopen;
      //连接错误
      this.ws.onerror   = this.wsOnerror
      //接收信息
      this.ws.onmessage = this.wsOnmessage;
      //连接关闭
      this.ws.onclose = this.wsOnclose;
      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      // window.onbeforeunload = this.onbeforeunload
    },
    wsSend(data){ // 发送消息 ws
      console.log(data)
      if(!this.wsLinked) {
        this.$toast('对不起，留言服务器正在连接当中，请稍后再试')
        return;
      }
      this.ws.send(JSON.stringify(data));
      this.btnIsSend = false
    },
    wsOnopen() {
      console.log('wsOnopen')
      console.log('WebSocket连接成功', this.ws.readyState)
      this.wsLinked = true;

      //开启心跳
      heartCheck.start(this.ws)
    },
    wsOnerror(e) {
      console.log('WebSocket连接发生错误', e)
      console.log("WebSocket连接发生错误" + '   状态码：' + this.ws.readyState)
      this.reconnect() // 重连
    },
    wsOnmessage(e){ // 接收信息
      try {
        var that = this
        // console.log('WebSocket获取数据', e)
        const data = JSON.parse(e.data);
        console.log(data)
        if (data.type=='pong'){
          // console.log('接收到后端心跳')
          var aData = new Date();
          console.log('接收到后端心跳'+ aData)
          //收到服务器信息，心跳重置
          // this.reset();
        } else{
          // console.log('默认')
            if (data.code==200)
            {
              if (data.data.type== 'init')
              {
                var content = data.data.content
                this.welcomeMsg = content
                console.log('res',content)
                // is_first: 1, // 1是第一次进来 0不是
                if(this.is_first==1){
                  that.sendComeIn() // 进入直播间特效提醒
                }
                if(!this.wsLinked) {
                  this.$toast('对不起，留言服务器正在连接当中，请稍后再试')
                  return;
                }
                this.sendList(content) // 消息列表
                // var wsMsg = setTimeout(() => {
                //
                //   clearTimeout(wsMsg)
                // }, 10000)


              } else if(data.data.type== 'welcome'){ // 别人进来
                var content = data.data.content
                this.welcomeMsgHe = content
                console.log('welcometa',content)
                that.sendComeInHe() // 进入直播间特效提醒
              } else if (data.data.type=='chat') { // // 聊天信息

                console.log('聊天信息')
                let obj = data.data.content
                if (obj.type==1){ // 红包
                  that.addTimeOut(obj);
                  this.redCurrItem = obj
                  this.redPacketShow = true
                  this.redType=2

                } else {
                  obj.is_translate = false
                  obj.content_sec = ''
                  that.addTimeOut(obj);
                }
                // that.addTimeOut(obj);
                // console.log(obj)


              }else if(data.data.type=='gift'){ // 礼物 showGiftList: [], // 弹层礼物列表  // '礼物1','礼物2'
                let activeItem = data.data.content
                if (activeItem){
                  this.showGiftList.push(activeItem); // //符合权限的消息添加到消息队列中
                  //播放的队列中有一条消息(消息队列从空值到有第一条消息时调用显示消息弹框和声音的方法,
                  //如果消息队列已经超过一条,这时动画正在进行不做任何操作)

                }

                // this.giftData = data.data.content
                this.giftShowAnimation() // 显示gift 动画

              }else if(data.data.type=='bot-chat'){ // 客服回复

                let obj = {
                  nickname: data.data.nickname,
                  content: '您是否想咨询以下问题，请点击相关的问题获取详情',
                  arr: data.data.content,
                  content_sec:'',
                  is_translate:false
                }
                that.addTimeOut(obj);

              } else if (data.data.type=='bonuses')
              { // 优惠券
                console.log('优惠券')
                this.discountShow = true
                this.discountInfo = data.data.content
                this.pressTimer = setTimeout(() => {
                  this.discountShow = false
                    clearTimeout(this.pressTimer)
                }, 10000)

              }else if (data.data.type=='pull')
              {
                console.log('历史消息')
                let arr = []
                arr = data.data.list
                arr.forEach(function(val,key,arr){
                  arr[key].is_translate=false
                  arr[key].content_sec = ''
                })
                this.msgList = arr
                let wsMsg = setTimeout(() => {
                  this.scrollBottom()
                  clearTimeout(wsMsg)
                }, 800)

              }else if (data.data.type=='click') // 直播间人数
              {
                console.log('直播播间人数',data.data.content.click)
                let number = data.data.content.click
                this.clickNumber = number
              }
            }else if(data.code==501) {
                this.$toast(data.message+'请重新进入直播间')
            }
            else
            {
                this.$toast(data.message)
            }

        }

        // 消息获取成功，重置心跳
        heartCheck.start(this.ws)
      } catch (e) {
        console.error('e: ', e)
      }
    },
    wsOnclose(e) { //  // 关闭
      console.log('连接已关闭...')
      console.log('connection closed (' + e.code + ')')
      this.wsLinked = false;
      this.is_first = 0
      if (this.wsLinked== false){
        this.reconnect() // 重连
      }

    },
    reconnect() { //  重连
      console.log('尝试重连')
      if (this.lockReconnect || this.maxReconnect <= 0) return
      setTimeout(() => {
        this.maxReconnect-- // 不做限制 连不上一直重连
        this.iniWs()
      }, 3 * 1000)
    },
    testSendYh(){
      console.log('获取优惠券')
      let b = new Date().getTime()
      var obj={
        type:'bonuses',
        liveroomId:this.liveroomId,
        token: this.zhiBoToken,
        microtime:b
      }
      console.log('模拟发送优惠券', obj)
      this.ws.send(JSON.stringify(obj))
    },
    sendList(item){ // 获取历史消息列表
      console.log('获取历史消息')
      let b = new Date().getTime()
      console.log(b)
      var obj={
        type:'pull',
        liveroomId:this.liveroomId,
        token: this.zhiBoToken,
        microtime: b,
        nickname: item.nickname
      }
      // console.log('获取历史信息obj',obj)
      this.ws.send(JSON.stringify(obj))
    },
    clickCoupon(){ // 领取优惠券
      if (this.discountInfo.number >=1){
        var id = this.discountInfo.id
        getDiscountCoupon(id).then(res => {
          if(res.code == 200)
          {
            console.log('res',res)
            this.discountSucceed = true
            // this.$toast('领取成功')
            // setTimeout(() => {
            //   //通知父组件关闭
            //   console.log('调列表数据')
            //   clearTimeout(this.pressTimer)
            //   this.discountShow = false
            // }, 1000);

          }
          else
          {
            this.$toast.setDefaultOptions({ duration: 2000 });
            this.$toast(res.message)
          }
        })
      } else {
        this.$toast('已经领完~')
      }
    },
    clickCouponSucceed(){ // 领取成功提示关闭
      this.discountSucceed = false
    },
    autoPlayVideo() {
      //页面初始化加载完毕自动播放视频
      this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady(res) {
        console.log('视频可以播放了',res);
        this.on("loadedmetadata",function(){ // //加载到元数据后开始播放视频
          console.log("获取资源长度完成 ")

        })
        this.on("canplaythrough",function(){

          console.log("视频源数据加载完成")
        })
        this.on("waiting", function(){
          console.log("等待数据")

        });
        this.on("play", function(){

          console.log("视频开始播放")
          // 获取当前播放时间
       //    let curr = this.currentTime()
       //    // 直播流缓存的最新帧
       //    let buffer = this.buffered().end(0)
       // // 判断delayTime 如果延迟小于5s(自己定义)认为卡顿
       //   // 计算延迟
       //    let delayTime = buffer - curr
       //    this.timerPlay = setInterval(()=>{ // 循环执行setInterval
       //      delayTime = this.buffered().end(0) - this.currentTime()
       //      if (delayTime < 5) {
       //        // 调用video的load()方法
       //        this.load()
       //      }
       //    },1000)

        });
        this.on('error', function(){
          this.errorDisplay.close();   //将错误信息不显示
          // 自定义显示方式
        })

        // 监听视频播放开始
        this.on("playing", function(){
          console.log("视频播放中")
        });
        this.on("error", function(){
          console.log("加载错误")
        });


// 监听video播放器播放时间的变化
//         this.on('timeupdate',function () {
//           console.log("正在播放------");
//
//           // 计算表最新推流的时间和现在播放器播放推流的时间
//           let differTime = this.buffered().end(0) - this.currentTime();
//
//           console.log(differTime);
//           // 差值小于1.5s时根据1倍速进行播放
//           if (differTime < 1.5){
//             this.playbackRate(1);
//           }
//           // 差值大于1.5s小于10s根据1.2倍速进行播放
//           if (differTime > 10) {
//
//             this.playbackRate(1.2);
//           }
//         })

        this.on("ended", function(){
          console.log("播放结束")
        });
        // this.player.on('playing', function () {
        //   // 监听视频播放开始
        //   this.player.hide();
        //   this.player.hide();
        // });

      });

    },
    clickLike(){ // 点赞
      zhoboDesLike(this.live_id).then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data)
          this.likesNumber += 1
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    // 表情
    faceContent() {
      this.faceShow = !this.faceShow;
      if (this.faceShow == true) {
        for (let i in appData) {
          this.faceList.push(appData[i].char);
        }
      } else {
        this.faceList = [];
      }
    },
    // 获取用户点击之后的标签 ，存放到输入框内
    getBrow(index) {
      for (let i in this.faceList) {
        if (index == i) {
          this.getBrowString = this.faceList[index];
          this.textConent += this.getBrowString;
          console.log(this.textConent)
        }
      }
    },
    // 将input的内容渲染到页面上
    referContent() { // 发送
      var that = this
      if (this.textConent == "") return alert("请输入内容");
      // 存入 {"type":"chat","liveroomId":"2","content":"大家好","uid":3}
      const opt = {
        content: this.textConent,
        type: 'chat',
        liveroomId:this.liveroomId,
        token: this.zhiBoToken,
        nickname: this.welcomeMsg.nickname
      }
      that.btnIsSend = true // 发送多次
      // console.log(this.textConent)
      this.wsSend(opt) // 第一种

      // 清空input数据
      this.textConent = "";
      // 关闭表情列表
      this.faceShow = false;
      this.msgShow = false
    },
    details(item){ // 发送资讯详情
      console.log(item)
      const opt = {
        content: item.content,
        type: 'bot-chat',
        liveroomId:this.liveroomId,
        token: this.zhiBoToken,
        nickname: this.welcomeMsg.nickname
      }
      this.wsSend(opt) // 第一种
    },
    hideClick(){ // 关闭输入框
      // 清空input数据
      this.textConent = "";
      // 关闭表情列表
      this.faceShow = false;
      this.msgShow = false
    },
    sendComeIn(){ // 进入直播间特效
      if(!this.comeInAnimation) { // 动画已经停止了 点了新的礼物 执行新的定时器
        this.comeInAnimation = true
        let commeAnimation = setInterval(()=>{
          clearInterval(commeAnimation);
          this.comeInAnimation = false;
        },2000)
      }
    },
    sendComeInHe(){ // ta ren 进入直播间特效
      if(!this.comeInAnimationHe) { // 动画已经停止了 点了新的礼物 执行新的定时器
        console.log('comeInAnimationHe',this.comeInAnimationHe)
        this.comeInAnimationHe = true
        let commeAnimation = setInterval(()=>{
          clearInterval(commeAnimation);
          this.comeInAnimationHe = false;
        },2000)
      }
    },
    initDom() {
      console.log('initDom')
      this.wrapperDom = this.$refs.wrapper;
      this.listDom = this.$refs.list;
      this.wrapperHeight = this.wrapperDom.offsetHeight;
    },
    addTimeOut(opt) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.addComment(opt);
          resolve()
        }, 500);
      });
    },
    // 队列添加消息
    async queue(data) {
      for (let i = 0; i < data.length; i++) {
        const opt = {
          nickname: i + "-用户名",
          content: i + "-评论内容",
          id: Date.now()
        }
        await this.addTimeOut(opt);
      }
    },
    addScroll() {
      debounce(this.listScroll, 200);
      this.isBindScrolled = true;
    },
    listScroll() {
      const ele = this.wrapperDom;
      const isBottom = isScrollBottom(ele, ele.clientHeight);
      if (isBottom) {
        this.restNums = 0;
        this.restComment = 0;
      }
    },
    // 添加评论 如果超过150条就将前50条删除
    addComment(data) {
      // if (this.msgList.length >= 150) { // 添加评论 如果超过150条就将前50条删除
      //   this.list.splice(0, 50);
      // }
      this.msgList.push(data);
      this.$nextTick(() => {
        this.renderComment();
      });
    },
    // 渲染评论
    renderComment() {
      const listHight = this.listDom.offsetHeight;
      const diff = listHight - this.wrapperHeight; // 列表高度与容器高度差值
      const top = this.wrapperDom.scrollTop; // 列表滚动高度
      // console.log('top',top)
      if (diff - top < 50) {
        // console.log('if')
        if (diff > 0) {
          if (this.isBindScrolled) {
            this.isBindScrolled = false;
            this.wrapperDom.removeEventListener("scroll", this.addScroll);
          }
          this.wrapperDom.scrollTo({
            top: diff + 10,
            left: 0,
            behavior: "smooth"
          });
          this.restNums = 0;
        }
      } else {
        // console.log('zheli else')
        ++this.restNums;
        if (!this.isBindScrolled) {
          this.isBindScrolled = true;
          this.wrapperDom.addEventListener("scroll", this.addScroll);
        }
      }
      this.restComment = this.restNums >= 99 ? "99+" : this.restNums; // 判断消息提现数字
    },

    scrollBottom() { // 点击消息提醒滚动到底部
      this.restNums = 0; // 清除剩余消息
      this.restComment = this.restNums;
      this.wrapperDom.scrollTo({
        top: this.listDom.offsetHeight,
        left: 0,
        behavior: "smooth"
      });
    },
    goCart(){
      this.$router.push('/cart')
    },
    /**
     * 播放器事件回调
     */
    handleReady(e) {
      console.log(`ready`, e);
     // this.getInit()
    },
    canplay(e){
      console.log(`canplay`, e);
    },
    errorClick(e){
      // https://github.com/langyuxiansheng/vue-aliplayer-v2
      var msg = e.paramData.display_msg
      this.$notify({ type: 'success', message: msg+'请重新进入' });
      console.log(`err`, e.paramData.display_msg);
    },
    // 高度自适应
    height () {
      let width = document.documentElement.clientWidth
      let h = `${width / 1.7777778}px`
      this.options.height = h
    },
    goDes(item){
      if (item.is_onepay==1){
        this.$router.push('/oneYuan')
      } else {
        this.$router.push({path:'/goodDetails',query: {id: item.id}})
      }

    },
    goQuan(){
      this.$router.push('/discountCoupon')
    },
    clickShowBag(){ // 点击购物袋
      if (this.goodsList != ''){
        this.shopBig = true
      } else {
        this.$toast('暂无商品')
      }
    },
    clickShowBagOne(){
      if (this.goodsListOneArr != ''){
        this.shopBigOne = true
      } else {
        this.$toast('暂无商品')
      }
    },
    showGift(){ // 显示礼物弹框
      this.gift_show = true
      if (this.giftList == ''){
        zhiboListgGift().then(res=>{
          if (res.code==200){
            this.giftList = res.data
          }else {
            this.$toast(res.message)
          }
        })
      }

    },
    clickGiftItem(item,index){ // 点击选中的礼物
      // console.log('liwu',item)
      this.giftObj = item
      this.activeGift = index
      // this.giftShowAnimation() // 显示gift 动画
      // this.gift_show = false

    },
    clickCloseGift(){ // 关闭
      this.activeGift = -1
    },
    clickPayGift(item,index){ // 点击赠送按钮
      this.giftObj = item
      this.submitGiftPay()
    },
    giftShowAnimation(){ // 直播间礼物特效 礼物做了排队展示的处理，可以解决礼物连续发送、监听到别人发送礼物接口数据回调的排队问题，不会冲刷掉礼物动效
      if(!this.show_gif) { // 动画已经停止了 点了新的礼物 执行新的定时器
        this.show_gif = true;
        let giftAnimation = setInterval(() => {
          if(this.showGiftList.length ===1) { // 最后一个数组 也是要停止定时器
            this.showGiftList.shift();
            clearInterval(giftAnimation);
            this.show_gif = false;
          }else if(this.showGiftList.length) { // 有长度的话 就必须要删除数组
            // console.log('有长度的话',this.showGiftList)
            this.showGiftList.shift(); // 将一个数组的第一个元素移出
          }else { //  没有数组的时候 就要停止定时器
            clearInterval(giftAnimation);
            this.show_gif = false;
          }
        }, 2000);
      }else {}// 正在进行动画的话 就不再添加定时器

    },
    submitGiftPay(){ // 礼物支付
      let id = this.live_id
      console.log()
      const data= {
        live_room_gift_id:this.giftObj.id
      }
      giftPay(id,data).then(res =>{
        if (res.code == 200){
          let url = res.data.url
          window.location.href=url // 安卓ok
          window.open(url) // ios no
          this.sendGiftDisabled = false
          this.gift_show=false
        }else {
          this.$toast(res.message)
          this.sendGiftDisabled = false
        }
      })
    },
    tabChange(e) {
      this.activeNav = e
    },
    panelShow(){
      // this.$toast('开发中')
      this.msgShow = true


    },
    goPage(){
      if (window.history.length <= 1) {
        this.$router.push({path:'/'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    getInit(){
      var _this = this
      let player = new Aliplayer({
        id: 'J_prismPlayer',
        width: '100%', //容器的大小
        height: '100%', //容器的大小
        autoplay: true,
        prismType: 2,
        vid: '',
        isLive: true,
        format: 'm3u8',  //切换为直播流的时候必填
        accId: '',
        accSecret: '',
        apiKey: '',
        source: this.video_src,  //视频地址
        showBarTime: 3000000,
        // x5_fullscreen:true,
        // x5_orientation: 'landscape', // 横屏
        // autoPlayDelayDisplayText: '加载中',
        // cover: 'http://liveroom-img.oss-cn-qingdao.aliyuncs.com/logo.png'
      },function(player){
        console.log('播放器创建了');
      });
    },
    getDes(){
      let that = this
      let data = {
        password:this.password
      }
      zhoboListDes(this.live_id,data).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data)
          this.live_info = res.data
          this.video_src = res.data.pull_url // res.data.pull_url // m3u8
          this.video_cover = res.data.cover
          this.video_title = res.data.title
          this.goodsList = res.data.goods
          let arr = res.data.goods
          let goodsOne = []
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].is_onepay==1){
              goodsOne.push(arr[i])
            }
          }
          this.goodsListOneArr = goodsOne
          // console.log('goods',goodsOne)
          this.likesNumber = res.data.likes
          this.clickNumber = res.data.click
          this.liveroomId = res.data.id
          this.live_status = res.data.live_status // 1 直播中 2热播 0 未开始
          this.live_time = res.data.live_time
          if (this.live_info.subscribable){
            this.isdy = true
          } else {
            this.isdy = false
          }
          let zhiToken = this.$store.state.zhiBoToken
          if (zhiToken != ''){ // 判断是否有token
            // console.log('有token')
            this.zhiBoToken = this.$store.state.zhiBoToken
            this.iniWs() // 第一种方式 功能没做好要隐藏
          } else {
            this.getWsToken() // 获取直播token
          }
          // this.getWsToken() // 获取直播token
          this.wxSubscribe() // 初始化微信

          this.$nextTick(function(){
            if (this.video_src != null && (this.live_status == 1 || this.live_status == 2)){
              console.log('video !null')
              //通知父组件关闭
              console.log('播放')
              if (this.phoneType ==2) { //2ios
                // 兼容微信(微信可以自动播放)
                console.log('ios')
                this.options.controls = true
                this.options.controlBar =false
                this.options.poster= this.video_cover
                this.autoPlayVideo()
                // 兼容微信(微信可以自动播放)

              } else { // 1 安卓
                this.options.controls = true
                this.options.controlBar =false
                this.options.poster= this.video_cover
                this.autoPlayVideo()
              }

            }
          })
          // 调用互动消息
          this.initDom(); // 获取消息列表高度功能没做好要隐藏

          // const data = new Array(20).fill('');
          // this.queue(data);
          // setTimeout(() => {
          //   const list = new Array(10).fill('');
          //   this.queue(list);
          // }, 10000);
        // 调用互动消息end

          //   this.showTimes() // 倒计时
        } else if (res.code ==403){ // 直播间密码错误
          that.pwd_is_err = false
          this.$toast(res.message)
          this.$router.replace({path:'/roomPassword',query:{id:this.live_id}})
        } else {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    showTimes(val) { // 倒计时
      let that = this;
      let interval = setInterval(() => {
        let nowTime = new Date().getTime(); // 当前时间
        let startDate = that.endTime; // 四点钟倒计时
        startDate = startDate.replace(new RegExp('-', 'gm'), '/');
        let startDateM = new Date(startDate).getTime(); //得到毫秒数
        // console.log('startDate',startDate)
        let lefttime = startDateM - nowTime;
        if (lefttime > 0) { // 倒计时中
          that.showTime.H = Math.floor(lefttime / (1000 * 60 * 60)) < 10 ? '0' + Math.floor(lefttime / (1000 * 60 * 60)) : Math.floor(lefttime / (1000 * 60 * 60)); //计算小时数
          that.showTime.M = Math.floor((lefttime / (1000 * 60)) % 60) < 10 ? '0' + Math.floor((lefttime / (1000 * 60)) % 60) : Math.floor((lefttime / (1000 * 60)) % 60); //计算分钟数
          that.showTime.S = Math.floor((lefttime / 1000) % 60) < 10 ? '0' + Math.floor((lefttime / 1000) % 60) : Math.floor((lefttime / 1000) % 60); //计算秒数
          this.msTxtShow = false //  false:显示倒计时  true：显示秒杀中
        } else { // 秒杀时间<=现在<次日0点：秒杀中
          console.log('倒计时结算')
          this.msTxtShow = true
          // this.msTxtShow = true //  false:显示倒计时  true：显示秒杀中
          that.showTime.H = '00';
          that.showTime.M = '00';
          that.showTime.S = '00';
          clearInterval(interval);
        }
      }, 1000);
    },
    createVideo() {
      if (flvjs.isSupported()) {
        var videoElement = document.getElementById('videoElement');
        var flvPlayer = flvjs.createPlayer({
          type: 'flv',
          isLive:true,
          url: this.video_src //  //你的url地址
        });
        flvPlayer.attachMediaElement(videoElement);
        flvPlayer.load();
        flvPlayer.play();
      }
    },
    /**
     * 更改配置
     */
    aclick(){
      this.player.src([
        {
          type: 'rtmp/flv',
          src: 'rtmp://58.200.131.2:1935/livetv/hunantv'//湖南直流地址
        }
      ])
    },
    bclick(){
      this.player.src([
        {
          type: 'video/mp4',
          src: 'https://v-cdn.zjol.com.cn/280443.mp4'//一个网上宣传的小视频地址
        }
      ])
    },
    shareShowHide(){

      this.shareShow = false
    },
    shareClick(){ // 生成二维码
      var id = this.live_info.id
      let baseUrl = ''
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url+`/zhiBoDes?id=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'
      // console.log(baseUrl)
      let qrcodeUrl = baseUrl
      QRCode.toDataURL(qrcodeUrl, (err, qr) => {
        if (err) {
          this.$toast('生成二维码失败');
        } else {
          this.qrcodeUrl = qr;
          console.log(this.qrcodeUrl)
          this.shareShow = true
          this.drawPoster()
        }
      });

    },
    drawPoster(){

      this.painting = {
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px',
        views: [
          {
            type: 'rect',
            css: {
              width: '502px',
              height: '876px',
              right: '9px',
              bottom: '6px',
              borderRadius: '10px',
              borderWidth: '8px',
              color: '#ffffff',
              borderColor: '#FDD80D',
            }
          },
          {
            type: 'image',
            url: this.live_info.cover,// this.shareGoodsImg, // 'https://www.sunniejs.cn/static/avatar.png'
            css: {
              width: '370px',
              height: '370px',
              top: '50px',
              left: '75px'
            }
          },
          {
            type: 'text',
            text: this.live_info.title,
            css: [
              {
                top: '450px',
                width: '400px',
                maxLines: 2,
                lineHeight: '50px',
                left: '60px',
                fontSize: '26px',
                textAlign: 'center'
              }
            ]
          },
          {
            type: 'image',
            url: this.qrcodeUrl,
            css: {
              width: '170px',
              height: '170px',
              top: '550px',
              left: '175px'
            }
          },
          {
            type: "text",
            text: "长按二维码保存图片",
            css: {
              top: "750px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
              color: '#E43A0D'
            }
          }
        ]
      }
    },
    //成功生成海报
    success(src) {
      this.posterUrl = src;
      // console.log(src)
    },
    fail(err) {
      // alert(err)
      console.log('fail', err)
    },
  },
}
const heartCheck = {
  timeout: 10 * 1000,
  timer: null,
  serverTimer: null,
  reset() {
    this.timer && clearTimeout(this.timer);
    this.serverTimer && clearTimeout(this.serverTimer);
  },
  start(ws) {
    this.reset();
    this.timer = setTimeout(() => { // //每10秒执行一次myFunction()
      // onmessage拿到返回的心跳就说明连接正常
      //这里发送一个心跳，后端收到后，返回一个心跳消息，
      ws.send(JSON.stringify({type:'ping'}));
      var aData = new Date();
      console.log('发送心跳,后端收到后，返回一个心跳消息'+ aData)
      this.serverTimer = setTimeout(() => {
        // 如果超过一定时间还没响应(响应后触发重置)，说明后端断开了
        ws.close();
      }, this.timeout);
    }, this.timeout);
  }
};
</script>

<style lang="scss" scoped>
 .gift-wrapper{

   margin-top: 40px;
   .gift-list{
     flex-wrap: wrap;
     display: -webkit-box;
     display: -ms-flexbox;
     display: flex;
     padding: 20px;
     .gift-item{
       width: 33%;text-align: center;margin-bottom: 20px;
       .img-gift{
         width: 180px;height: auto;display: block;margin: 0 auto;
       }
       .pay-gift-sec{
         background: #eacf29;width: 100%;border-radius: 0;border: none;height: 70px;line-height: 70px;
       }
     }
     .gift-item-active{
       background: #c3c3c3;overflow: hidden;border-radius: 20px;
     }

   }
   .pay-gift{
     width: 80%;margin: 10px auto 0;border-radius: 50px;display: block;
   }
 }
.show-gift-img{
  position:absolute;width: 100%;height: 80%;z-index: 1;top: 10%;text-align: center;
  img{
    width: 100%;height: auto;
  }
}
.list-language-box{
  width: 80%;margin: 150px auto 0;
  .language-item{
    color: #00d0ff;
    text-decoration: underline;
  }
}
.van-action-sheet__close{
  color: #5f5f5f;
}
.show-default{
  margin-top: 10px;
}
.left-justifying2{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.red-packet-bpx{
  text-align: center;position: relative;width:500px;margin: 270px auto 0;z-index: 999;
  .red-packet-bpx-img{
    width:500px;height: auto;display: block; margin: 0 auto;
  }
  .money-box-red{
    position: absolute;width: 100%;left: 0;top:80px;color: #fff;font-size: 32px;
  }
  .red-packet-content{
    position: absolute;left: 7.5%;width: 85%;top:90px;z-index: 3;color: #FFFFFF;font-size: 32px;overflow: hidden;
    .red-packet-title{
      font-size: 32px;margin-bottom: 10px;
    }
    .red-packet-title-sec{

      font-size: 42px;
      font-weight: 800;
      span{
        font-size: 75px;
      }
    }
    .red-packet-hint-sec{
      margin-top: 120px;
    }
    .red-packet-time{
      font-size: 34px;
      font-weight: bold;
      color: #F3203A;margin-top: 60px;
    }
    .red-packet-get{
      color: #F3203A;font-size: 26px;
    }
    .red-packet-btn{
      width: 310px;
      height: 75px;line-height: 75px;
      background: linear-gradient(0deg, #FDDC48 0%, #F2BA3B 15%, #FFF0A9 85%, #FDF7E1 100%);
      box-shadow: 0px 1px 10px 0px #D72E2E;
      border-radius: 10px;font-size: 28px;color: #8D1111;text-align: center;margin: 82px auto 0;
    }
    .red-packet-btn-sec{
      margin-top: 30px;
      font-size: 36px;
      font-weight: bold;
      color: #8D1111;
    }
  }
  .open-btn{
    width: 210px;height: auto;display: block;position: absolute;left: 150px;top: 160px;
  }
}
//优惠券
.discount-box{
  position: relative;width:500px;margin: 270px auto 0;z-index: 88;
  .discount-img-bg{
    width: 100%;height: auto;display: block;margin: 0 auto;opacity: 0.7;
  }
  .discount-box-content{
    position: absolute;z-index: 55;left:0;top:130px;font-size: 100px;
    font-weight: bold;
    color: #F49F0A;width: 100%;text-align: center;
    .number{
      display: inline-block;
    }
    span{
      font-size: 50px;
    }
    .red-packet-hint{
      font-size: 35px;
      .number{
        font-size: 60px;
      }
      span{
        font-size: 35px;margin-left: 10px;
      }
    }
  }
  .ticket-priority-box{
    position: absolute;width: 70%;text-align: center;
    z-index: 55;left:15%;top:100px;
    .priority-title{
      width: 90%;margin: 0 auto;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .priority-title-sec{
      color: #c60707;overflow: hidden;width: 90%;margin: 5px auto;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .priority-goods{
      overflow: hidden;width: 90%;margin: 5px auto;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .priority-goods-hint{
      font-size: 24px;
    }
  }
  .ticket-priority-box-sec{
    font-size: 28px;color: #282828;
    top: -15px;
    .priority-title{
      width: 90%;margin: 0 auto;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .priority-title-sec{
      color: #c60707;overflow: hidden;width: 90%;margin: 5px auto;
      text-overflow: ellipsis;
      white-space: nowrap;
      span{
        font-size: 28px;
      }
    }
    .priority-goods{
      overflow: hidden;width: 90%;margin: 5px auto;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .priority-goods-hint{
      font-size: 24px;
    }
  }
  .discount-box-content-succeed{
    top:110px;
  }
  .discount-btn{
    position: absolute;z-index: 55;left: 90px;bottom: 65px;
    width: 310px;
    height: 75px;line-height: 75px;text-align: center;font-size: 28px;
    color: #8D1111;
    background: linear-gradient(0deg, #FDDC48 0%, #F2BA3B 15%, #FFF0A9 85%, #FDF7E1 100%);
    box-shadow: 0px 1px 10px 0px #D72E2E;
    border-radius: 10px;
  }
}
.video-div{
  object-fit:cover
}
.content-pop{

  .p-title-box{
    padding: 20px 100px 20px 20px;
    .title{
      font-weight: bold;
      color: #282828;font-size: 32px;
    }
    .pop-item{
      font-size: 18px;text-align: center;
      img{
        width: 40px;height: auto;display: block;margin: 0 auto;
      }
    }
  }
  .goods-list-box{
    padding: 0 15px 20px;
    .goods-item{
      margin-bottom: 20px;
      .goods-img-box{
        border-radius: 30px; width: 240px;
        height: 240px;overflow: hidden;position: relative;
        img{
          width: 240px;
          height: 240px;display: block;
        }
        .hint-num{
          text-align: center;
          background: rgba(0, 0, 0, 0.5);border-radius: 30px 0px 10px 0px;width: 64px;
          font-size: 22px;font-weight: 400;padding: 10px 0;
          color: #FFFFFF;
          position: absolute;left: 0; top: 0;
        }
      }
      .goods-content{
        width: 450px;margin-left: 20px;position: relative;height: 240px;
        .goods-title{
          text-align: left;font-size: 28px;line-height:40px;
        }
        .goods-des{
          position: absolute;bottom: 0;left: 0;width: 100%;
          .price-box{
            font-weight: 400;
            color: #F23926;
            span{
              font-weight: bold;
              color: #F23926;font-size: 50px;
            }
          }
          .buy-news{
            width: 127px;
            padding: 10px 15px;
            background: #FDD80D;
            border-radius: 32px;font-weight: bold;text-align: center;
            color: #f32926;
          }
        }
      }
    }
  }
}
.live-wrapper {
  .rt-box{
    padding-right: 20px;
    .vr-img{
      width: 70px;height: auto;
    }
    .yue-img{
      width: 52px;height: auto;display: inline-block;margin-right: 20px;
    }
    .div-number{
      background: rgba(0,0,0,0.5);padding: 8px 15px 7px 15px;
      color: #FFFFFF;font-size: 24px;margin-left: 10px;border-radius: 50px;
      img{
        width: 18px;height: auto;margin-left: 4px;margin-right:5px;
      }
      .hint-num{
        font-size: 18px;font-weight: normal;margin-left: 10px;display: inline-block;margin-top: -5px;
      }
    }
  }
  background: #000;
  position: relative;
  .lp-player-box{
    position: relative;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    .video-box{
      z-index: 1;
      position: absolute;
      width: 100%;
      height: 100vh;left: 0;
      object-fit: cover;top: 0;
      .vjs-tech{
        position: absolute;
        width: 100%;
        height: 100vh;left: 0;
      }
    }
    .player{
      z-index: 1;
      position: absolute;
      width: 100%;
      height: 100vh;
      object-fit: fill;left: 0;top: 0;
    }
  }
  .lp-player-btn{
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: 999;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 50px;
    color: #fff;
    background: rgba(0,0,0,.3);top: 0;
  }
  .fake-chat-msg{
    width: 520px;
    position: absolute;
    left: 24px;
    bottom: 190px;
    z-index: 2;
    height: 320px;
    overflow: hidden;
    .fake-chat-inner{
      position: relative;
      .item{
        border-radius: 15px;
        background: #383838;
        color: #fff;
        padding: 10px 10px;
        margin-bottom: 5px;text-align: left;font-size: 24px;
      }
      .nickname {
        color: #FFECBD;
      }
    }
    .comment-wrap{
      height: 320px;
      overflow-y: scroll;
      -webkit-overflow-scrolling:touch;
    }
    #list-msg{
      width: 100%;overflow: hidden;
    }
    .comment-wrap .li{
      text-align: left;
      //line-height: 60px;
      padding-left: 15px;padding-top: 10px;padding-right: 2px;
      background: rgba(33, 32, 32, 0.5);
      margin-top: 10px;
      border-radius: 40px;padding-bottom: 5px;
      color: #fff;
      .red-box{
        width: 240px;
        height: 104px;
        background: #FFA500;margin-top: 10px;
        border-radius: 10px;display: inline-block;margin-bottom: 10px;
        .red-bag-title{
          font-size: 26px;line-height:auto !important;padding: 0 10px;border-bottom: 1px solid #efefef;
          img{
            width: 42px;height: auto;display: inline-block;
          }
        }
        .red-name{
          font-size: 20px;line-height:40px !important;padding: 0 10px;
          overflow: hidden;
        }
      }
    }
    .rest-nums{
      position: absolute;
      height: 30px;
      line-height: 30px;
      color: #f00;
      border-radius: 15px;
      padding: 5px 15px;
      bottom: 10px;
      background: #fff;
      font-size: 26px;
      left: 10px;
    }
  }
}
.left-justifying3{
  .nickname{
    width: auto;display: inline-block;margin-right: 5px;vertical-align:top;
  }
  .content-sec{
    //width: auto;
  }
}

#lp-header{
  color: #fff;
  z-index: 2;
  position: absolute;
  width: 100%;top: 0;left: 0;
  .lp-ht-row{
  }
  .lp-ht-row:nth-child(1) {
    background: linear-gradient(rgba(0,0,0,.8),transparent);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
  }
  .lp-ht-row:nth-child(1) span {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    //padding: 15px;
  }
  .lp-ht-row:nth-child(1) span:nth-child(1) strong {
    position: relative;
    font-size: 26px;
    font-weight: 400;
    width: 300px;
    height: 80px;
    overflow: hidden;
  }
  //.lp-ht-row:nth-child(1) span:nth-child(1) strong strong {
  //  width: 500%;
  //  position: absolute;
  //  animation: 10s lp-header-move infinite linear;
  //  left: 0;
  //  top: 0;
  //}
}
.qr-code-box{
  position: absolute;top: 90px;z-index: 3;right: 20px;text-align: right;
  font-size: 22px;
  font-weight: bold;
  color: #FDD80D;
  line-height: 26px;
  .qr-code{
    width: 74px;
    height: 74px;
    background: #FFFFFF;
    border-radius: 6px;color: #999;font-size: 70px;text-align: center;display: inline-block;margin-top: 15px;
  }
}
.lp-icon-group{
  z-index: 3;
  position: absolute;
  .lp-icon-item{
    //width: 60px;
    //height: 60px;
    //border: 1px solid #3c8ee5;
    //margin-bottom: 10px;
    text-align: center;
    color: #FDD80D;font-size: 24px;
    margin-bottom: 20px;
    img{
      width: 80px;
      height: auto;display: block;
    }
  }
}
#lp-icon-1{
  top: 120px;
  left: 15px;
  .lp-icon-item{

  }
}
#lp-icon-4{
  top: 350px;
  right: 15px;
  .lp-icon-item{
    margin-bottom: 30px;
    img{
      width: 72px;
      height: auto;display: block;
    }
  }
}
#panel-wrapper {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  //transition: all 0.8;
  .close-btn {
    text-align: center;
    padding: 10px;
    margin-bottom: 20px;
    span {
      background: rgba(0,0,0,.5);
      color: #fff;
      padding: 10px 15px;
      font-size: 26px;
      border-radius: 5px;
    }
  }
  .panel {
    background: rgba(0,0,0,.5);
    color: #fff;
    height: 600px;
    margin-bottom: 0;
    border: 1px solid transparent;
    border-radius: 8px;
    overflow: hidden;
    .panel-title {
      //transition: all .8;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center; width: 100%;
      span {
        display: inline-block;
        width: 25%;padding: 20px 0;
      }
      .current {
        transition: all .8;
        background: rgba(0,0,0,.8);
      }
    }
    .panel-content{
      color: #fff;
      background: rgba(0,0,0,.8);
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }
  }
}
#fake-chat-form {
  position: absolute;
  left: 24px;
  bottom: 60px;
  width: 350px;
  z-index: 2;
  border-radius: 30px;
  background: #383838;
  color: #fff;
  padding: 15px 15px;
  font-size: 24px;text-align: left;
}
.gift-box{
  position: absolute;
  left: 420px;
  bottom: 60px; z-index: 2; border-radius: 30px;
  background: #383838;padding: 10px;
  img{
    width: 34px;height: auto;display: block;margin: 0 auto;
  }
}
.van-popup{
  background: rgba(255, 255, 255,0.8);
}
.van-action-sheet__close{
  color: #5f5f5f;
}

.input-box-bg{
  position: absolute;
  bottom: 0;left: 0; width: 100%;z-index:3;height: 100%;
}
.input-box{
  //position: fixed;
  //width: 100%;left: 0; bottom: 120px;
  background: #D0E1CB; position: absolute;bottom: 0;left: 0; width: 100%;z-index: 4;
  .send-btn{
    width: 140px;
    color: #FFFFFF;
    background: #55BB3A;text-align: center;border: none;
    //border-radius: 32px;
    margin-left:26px;
  }
  .input-content{
    padding: 20px 20px 20px;
    input{
      //width: 80%;margin: 0 15px;height: 60px;line-height: 60px;padding: 0 5px;
      width: 440px;margin-left: 10px;
      height: 66px;line-height: 66px;
      background: #FFFFFF;padding: 0 10px;
      border-radius: 33px;border: none;color: #282828;
    }
  }
  .browBox {
    width: 100%;
    height: 200px;padding-bottom: 40px;
    background: #e6e6e6;
    //position: absolute;
    //bottom: 0px;
    overflow: scroll;
    ul {
      display: flex;
      flex-wrap: wrap;
      padding: 10px;
      li {
        width: 14%;
        margin: 5px 0;
        font-size: 42px;
        list-style: none;
        text-align: center;
      }
    }
  }
}
.van-action-sheet__close{
  z-index: 999;
}
.van-overlay{
  background: none;z-index: 8;
}

/* video.js样式修改 */
.video-js { /* 给.video-js设置字体大小以统一各浏览器样式表现，因为video.js采用的是em单位 */
  font-size: 26px;
}

.video-js button {
  outline: none;
}

//.video-js.vjs-fluid,
//.video-js.vjs-16-9,
//.video-js.vjs-4-3 { /* 视频占满容器高度 */
//  height: 100%;
//  background-color: #161616;
//}

.vjs-poster {
  background-color: #161616;
}

.video-js{

}
.vjs-big-play-button { /* 中间大的播放按钮 */
  font-size: 30px !important;
  line-height: 50px;
  height: 50px;
  width: 50px;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  background-color: rgba(0, 0, 0, .3);
  border-width: 0;
  margin-top: 20px;
  margin-left:-20px;
}
.vjs-big-play-centered{
  //position: absolute;top: 0;left: 0;height: 100vh;width: 100%;
}
#myVideo{
  width: 750px;height: 100vh;
  display: block;
  //position: absolute;top: 0;left: 0;width: 100%;height: 100%;
  //object-fit: fill;
}
.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started .vjs-big-play-button {
  display: block;
}
.myVideo-dimensions.vjs-fluid{
  //padding-top:0;
}

.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3{ /* 视频占满容器高度 */
  height: 100%;
  background-color: #161616;
}



.playToggle{
  text-align: center;position: absolute;top: 50%;left: 50%;
}
.live-status-0{
  position: absolute;top: 42%;left: 0%;z-index: 3;color: #fff;width: 100%;text-align: center;font-size: 35px;
  font-weight: bold;letter-spacing: 10px;
  background: rgba(0,0,0,0.4);padding: 20px 0;

}
.live-status-0-img{
  width: 100%;height: 100%;position: absolute;left: 0;
  top: 0;z-index: 1;
}
//进入直播间提醒
.head-live-box{
  position: fixed;
  bottom: 650px;
  left: -60px;z-index:4;
  animation: mymove 2s infinite;
  border: 4px solid #fae7b8;
  border-radius: 60px;color: #FFFFFF;
  padding: 10px 20px;max-width: 60%;background: rgba(0,0,0,0.8);
  .name{
    max-width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;padding: 0 6px;
  }
  img{
    width: 40px;height: 40px;background: #cccccc;border-radius: 80px;display: inline-block;margin-right: 10px;
  }
}
.head-live-box-gift{
  animation: mymove 2s infinite;  position: fixed;  bottom: 520px;width: 50%;
  left: -60px;z-index:4;
  .head-live-box-gift-content{
    border: 2px solid #fae7b8;
    border-radius: 99px;color: #FFFFFF;
    padding: 10px 50px;background: rgba(0,0,0,0.8);font-size: 26px;max-width: 80%;
    .name{
      font-size: 30px;font-weight: bold;
      display: inline-block;
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow:ellipsis;
    }
  }
  .number-gift{
    color: #ffffff;font-size: 40px;margin-left: 10px;
    span{
      font-size: 28px;
    }
  }
}
@keyframes mymove { //滑动出来1s 停留展示1s
  0% {left: -60px;display: none;}
  1% {left: -60px;display: block;}
  50% {left: 80px}
  99% {left: 80px}
  100% {left: 80px;display: none;}
}

.chat-wrapper{
  position: fixed;
  width: 100%;
  left: 0;bottom:20px;z-index: 3;
  .goods-box{
    position: relative;
    img{
      width: 100px;height: auto;display: block;
    }
    .goods-number{
      position: absolute;width: 100%;left: 0;text-align: center;color: #fff;
      font-size: 36px;
      font-weight: bold;top: 42px;z-index: 2;
    }
  }
  .chat-wrapper-content{
    padding-bottom: 20px;
    .say-box{
      width: 420px;padding: 20px 20px; background: rgba(0,0,0,0.4);font-size: 30px;color: #FFFFFF;
      border-radius: 42px;margin-left: 15px;margin-right: 15px;
    }
    .bottom-item-box{
      .item-img{
        width: 84px;
        background: rgba(0,0,0,0.4);
        border-radius: 50%;padding: 16px 0;
        img{
          width: 52px;height: auto;display: block;margin: 0 auto;
        }
      }
    }
  }
}
.qr_zs_wrapper{
  //display: flex;
  //align-items: center;
  //justify-content: center;text-align: center;
  //height: 100%;
  .block {
    width: 350px;padding: 10px 0;
    background-color: #fff;border-radius: 8px;text-align: center;
    margin: 330px auto 0;
    img{
      width: 250px;
      height: 250px;display: block;margin: 20px auto 10px;
    }
  }

}
/deep/.van-field__control{color: #fff;}
.van-cell::after{border: 0}
.red_bag_wrapper{
  .block {
    width: 460px;padding: 30px 20px;
    border-radius: 10px;text-align: center; background:rgba(0,0,0,0.5);
    margin: 330px auto 0;
    .red-bag-item{
      padding: 10px 0;color: #fff;
      input{
        width: 230px;height: 60px;line-height: 60px;padding: 0 10px;margin-right: 20px;
        border: 2px solid #B7B7B7;
      }
      .input-bag{
        width: 230px;margin-right: 20px;height: 60px;line-height: 60px;padding: 0 10px;background: none;
        color: #fff;border-bottom: 1px solid #898989;
      }
      .red-name{
        width: 130px;
      }
    }
    .btn-red-bag-box{
      width: 80%;margin: 30px auto 0;
      .red-btn{
        width: 40%;color: #000000;background: #FDD80D;border: none;font-size: 28px;
      }
    }
  }
}

.wrapper{
  .icon-box{
    width: 630px;text-align: right;margin: 80px auto 30px;
    .icon-box-bg{
      display: inline-block;padding:15px;background: rgba(0,0,0,0.5);
    }
  }
  img{
    width: 520px;display: block;height: auto;margin: 0 auto;
  }
}


/* 订阅消息 */
.subscribe {
}

.subscribe-cont {
  position: relative;
  width: 52px;height: 52px;padding-right: 20px;
}

.subscribe-cont text {
  display: inline-block;
  -webkit-animation: subscribeCont 1s linear infinite;
  animation: subscribeCont 1s linear infinite;
}

@keyframes subscribeCont {
  25% {
    transform: scale(.98);
  }

  50%,
  100% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.05);
  }
}

.subscribe-icon image {
  width: 54px;
  height: 54px;
  margin-top: 14px;
}
//.nickname{
//  width: 150px;display: inline-block;margin-right: 5px;
//}
.translate-box{
  color: #00acff;padding-bottom: 25px;padding-top: 5px;
  span{
    display: inline-block;text-decoration: underline; margin-right: 15px; font-size: 26px;
  }
}
.content-sec{
  width: 280px;
}
@keyframes Tada {
  0% {
    transform: scale(1);
    transform: scale(1)
  }

  70%,
  73% {
    transform: scale(1) rotate(-3deg);
    transform: scale(1) rotate(-3deg)
  }

  77%,
  83%,
  90%,
  97% {
    transform: scale(1) rotate(3deg);
    transform: scale(1) rotate(3deg)
  }

  80%,
  87%,
  93% {
    transform: scale(1) rotate(-3deg);
    transform: scale(1) rotate(-3deg)
  }

  100% {
    transform: scale(1) rotate(0);
    transform: scale(1) rotate(0)
  }
}

.subscribe-icon-one {
  -webkit-animation: bounce-right 1s linear infinite;
  animation: bounce-right 1s linear infinite;
}

@keyframes bounce-right {
  25% {
    transform: translateX(-3px);
  }

  50%,
  100% {
    transform: translateX(0);
  }

  75% {
    transform: translateX(3px);
  }
}

.subscribe-icon-two {
  -webkit-animation: bounce-two 1s linear infinite;
  animation: bounce-two 1s linear infinite;
}

@keyframes bounce-two {
  25% {
    opacity: 0;
    transform: translateX(-3px);
  }

  75% {
    opacity: 1;
    transform: translateX(3px);
  }
}

subscribe-btn {
  width: 100%;
  height: 200px;
  text-align: center;
  line-height: 150px;
  font-size: 30px;
  font-weight: 500;
  color: #ffffff;
  background-color: green;
  position: relative;
  overflow: hidden;
}
#subscribe-btn{
  width: 100%;
  height: 100%;
  position: absolute;left: 0;top: 0;z-index: 888;
  //width: 100%;
  //height: 200px;
  //text-align: center;
  //line-height: 150px;
  //font-size: 30px;
  //font-weight: 500;
  //color: #ffffff;
  //background-color: green;
  //position: relative;
  //overflow: hidden;
}
.translate-box{
  //display: inline-block;
}

</style>
